import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=5c02c9d2&scoped=true"
import script from "./CityList.vue?vue&type=script&lang=js"
export * from "./CityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02c9d2",
  null
  
)

export default component.exports